export default {
  title: {
    en: 'All Sports',
  },
  top: {
    en: 'Top Events',
  },
}
